import type { ReactNode } from 'react';
import { styled } from 'styled-components';

import { useI18n } from '#/i18n/hooks/useI18n';
import { colors, spacing } from '#/theme/theme';

function TabLabel(props: {
  icon: ReactNode;
  count: number;
  className?: string;
  children: ReactNode;
}) {
  const { i18n } = useI18n();
  const { icon, count, className, children } = props;

  return (
    <div className={className}>
      <div className="tab-icon">{icon}</div>
      <div className="tab-label">
        {children}
        <div className="tab-count">
          {i18n('%(count)s %(listing)s', {
            count,
            listing: count === 1 ? 'listing' : 'listings',
          })}
        </div>
      </div>
    </div>
  );
}

export const ViewOrgPageListingsTabsTabLabel = styled(TabLabel)<{
  $active: boolean;
}>`
  display: flex;
  align-items: center;
  padding-left: ${spacing[24]};
  padding-right: ${spacing[24]};

  .tab-label {
    display: flex;
    flex-direction: column;
    font-size: 20px;
    color: ${(props) =>
      props.$active ? colors.brandBlue : colors.mediumContentGrey};
  }

  .tab-count {
    font-size: 16px;
  }

  .tab-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${spacing[40]};
    height: ${spacing[40]};
    background-color: ${(props) =>
      props.$active ? colors.brandBlue : colors.elementGrey};
    border-radius: 50%;
    margin-right: ${spacing[16]};
  }
`;
